/**
 * Specifies Workbook internal events.
 */
/** @hidden */
export const workbookDestroyed = 'workbookDestroyed';
/** @hidden */
export const updateSheetFromDataSource = 'updateSheetFromDataSource';
/** @hidden */
export const dataSourceChanged = 'dataSourceChanged';
/** @hidden */
export const dataChanged = 'dataChanged';
/** @hidden */
export const triggerDataChange = 'triggerDataChange';
/** @hidden */
export const workbookOpen = 'workbookOpen';
/** @hidden */
export const beginSave = 'beginSave';
/** @hidden */
export const beginAction = 'actionBegin';
/** @hidden */
export const sortImport = 'sortImport';
/** @hidden */
export const findToolDlg = 'findToolDlg';
/** @hidden */
export const exportDialog = 'exportDialog';
/** @hidden */
export const setFilteredCollection = 'setFilteredCollection';
/** @hidden */
export const saveCompleted = 'saveCompleted';
/** @hidden */
export const applyNumberFormatting = 'applyNumber';
/** @hidden */
export const getFormattedCellObject = 'getFormattedCell';
/** @hidden */
export const calculateFormula = 'calculateFormula';
/** @hidden */
export const refreshCellElement = 'refreshCellElem';
/** @hidden */
export const setCellFormat = 'setCellFormat';
/** @hidden */
export const findAllValues = 'findAllValues';
/** @hidden */
export const textDecorationUpdate = 'textDecorationUpdate';
/** @hidden */
export const applyCellFormat = 'applyCellFormat';
/** @hidden */
export const updateUsedRange = 'updateUsedRange';
/** @hidden */
export const updateRowColCount = 'updateRowColCount';
/** @hidden */
export const workbookFormulaOperation = 'workbookFormulaOperation';
/** @hidden */
export const workbookEditOperation = 'workbookEditOperation';
/** @hidden */
export const checkDateFormat = 'checkDateFormat';
/** @hidden */
export const checkNumberFormat = 'checkNumberFormat';
/** @hidden */
export const parseDecimalNumber = 'parseDecimalNumber';
/** @hidden */
export const getFormattedBarText = 'getFormattedBarText';
/** @hidden */
export const activeCellChanged = 'activeCellChanged';
/** @hidden */
export const openSuccess = 'openSuccess';
/** @hidden */
export const openFailure = 'openFailure';
/** @hidden */
export const sheetCreated = 'sheetCreated';
/** @hidden */
export const sheetsDestroyed = 'sheetsDestroyed';
/** @hidden */
export const aggregateComputation = 'aggregateComputation';
/** @hidden */
export const getUniqueRange = 'getUniqueRange';
/** @hidden */
export const removeUniquecol = 'removeUniquecol';
/** @hidden */
export const checkUniqueRange = 'checkUniqueRange';
/** @hidden */
export const reApplyFormula = 'reApplyFormula';
/** @hidden */
export const clearFormulaDependentCells = 'clearFormulaDependentCells';
/** @hidden */
export const formulaInValidation = 'formulaInValidation';
/** @hidden */
export const beforeSort = 'beforeSort';
/** @hidden */
export const initiateSort = 'initiateSort';
/** @hidden */
export const updateSortedDataOnCell = 'updateSortedDataOnCell';
/** @hidden */
export const sortComplete = 'sortComplete';
/** @hidden */
export const sortRangeAlert = 'sortRangeAlert';
/** @hidden */
export const initiatelink = 'initiatelink';
/** @hidden */
export const beforeHyperlinkCreate = 'beforeHyperlinkCreate';
/** @hidden */
export const afterHyperlinkCreate = 'afterHyperlinkCreate';
/** @hidden */
export const beforeHyperlinkClick = 'beforeHyperlinkClick';
/** @hidden */
export const afterHyperlinkClick = 'afterHyperlinkClick';
/** @hidden */
export const addHyperlink = 'addHyperlink';
/** @hidden */
export const setLinkModel = 'setLinkModel';
/** @hidden */
export const beforeFilter = 'beforeFilter';
/** @hidden */
export const initiateFilter = 'initiateFilter';
/** @hidden */
export const filterComplete = 'filterComplete';
/** @hidden */
export const filterRangeAlert = 'filterRangeAlert';
/** @hidden */
export const clearAllFilter = 'clearAllFilter';
/** @hidden */
export const wrapEvent = 'wrapText';
/** @hidden */
export const onSave = 'onSave';
/** @hidden */
export const insert = 'insert';
/** @hidden */
export const deleteAction = 'delete';
/** @hidden */
export const insertModel = 'insertModel';
/** @hidden */
export const deleteModel = 'deleteModel';
/** @hidden */
export const isValidation = 'isValidation';
/** @hidden */
export const cellValidation = 'cellValidation';
/** @hidden */
export const addHighlight = 'addHighlight';
/** @hidden */
export const dataValidate = 'dataValidate';
/** @hidden */
export const find = 'find';
/** @hidden */
export const goto = 'gotoHandler';
/** @hidden */
export const findWorkbookHandler = 'findHandler';
/** @hidden */
export const replace = 'replace';
/** @hidden */
export const replaceAll = 'replaceAll';
/** @hidden */
export const showFindAlert = 'showFindAlert';
/** @hidden */
export const findKeyUp = 'findKeyUp';
/** @hidden */
export const removeHighlight = 'removeHighlight';
/** @hidden */
export const queryCellInfo = 'queryCellInfo';
/** @hidden */
export const count = 'count';
/** @hidden */
export const findCount = 'findCount';
/** @hidden */
export const protectSheetWorkBook = 'protectSheet';
/** @hidden */
export const updateToggle = 'updateToggleItem';
/** @hidden */
export const protectsheetHandler = 'protectsheetHandler';
/** @hidden */
export const replaceAllDialog = 'replaceAllDialog';
/** @hidden */
export const unprotectsheetHandler = 'unprotectsheetHandler';
/** @hidden */
export const workBookeditAlert = 'editAlert';
/** @hidden */
export const workbookReadonlyAlert = 'readonlyAlert';
/** @hidden */
export const setLockCells = 'setLockCells';
/** @hidden */
export const applyLockCells = 'applyLockCells';
/** @hidden */
export const setMerge = 'setMerge';
/** @hidden */
export const applyMerge = 'applyMerge';
/** @hidden */
export const mergedRange = 'mergedRange';
/** @hidden */
export const activeCellMergedRange = 'activeCellMergedRange';
/** @hidden */
export const insertMerge = 'insertMerge';
/** @hidden */
export const hideShow = 'hideShow';
/** @hidden */
export const setCFRule = 'setCFRule';
/** @hidden */
export const applyCF = 'applyCF';
/** @hidden */
export const clearCFRule = 'clearCFRule';
/** @hidden */
export const clear = 'clear';
/** @hidden */
export const clearCF = 'clearCF';
/** @hidden */
export const setImage = 'setImage';
/** @hidden */
export const setChart = 'setChart';
/** @hidden */
export const initiateChart = 'initiateChart';
/** @hidden */
export const refreshRibbonIcons = 'refreshRibbonIcons';
/** @hidden */
export const refreshChart = 'refreshChart';
/** @hidden */
export const refreshChartSize = 'refreshChartSize';
/** @hidden */
export const deleteChartColl = 'deleteChartColl';
/** @hidden */
export const initiateChartModel = 'initiateChartModel';
/** @hidden */
export const focusChartBorder = 'focusChartBorder';
/** @hidden */
export const saveError = 'saveError';
/** @hidden */
export const updateHighlight = 'updateHighlight';
/** @hidden */
export const beforeInsert = 'beforeInsert';
/** @hidden */
export const beforeDelete = 'beforeDelete';
/** @hidden */
export const deleteHyperlink = 'deleteHyperlink';
/** @hidden */
export const moveOrDuplicateSheet = 'moveOrDuplicateSheet';
/** @hidden */
export const setAutoFill = 'setAutoFill';
/** @hidden */
export const refreshCell = 'refreshCell';
/** @hidden */
export const getFillInfo = 'getFillInfo';
/** @hidden */
export const getautofillDDB = 'getautofillDDB';
/** @hidden */
export const rowFillHandler = 'rowFillHandler';
/** @hidden */
export const getTextSpace = 'getTextSpace';
/** @hidden */
export const refreshClipboard = 'refreshClipboard';
/** @hidden */
export const updateView = 'updateView';
/** @hidden */
export const selectionComplete = 'selectionComplete';
/** @hidden */
export const refreshInsertDelete = 'refreshInsertDelete';
/** @hidden */
export const getUpdatedFormulaOnInsertDelete = 'getUpdatedFormulaOnInsertDelete';
/** @hidden */
export const beforeCellUpdate = 'beforeCellUpdate';
/** @hidden */
export const duplicateSheetFilterHandler = 'duplicateSheetFilterHandler';
/** @hidden */
export const unMerge = 'unMerge';
/** @hidden */
export const checkFormulaRef = 'checkFormulaRef';
/** @hidden */
export const parseFormulaArgument = 'parseFormulaArgument';
/** @hidden */
export const getCellRefValue = 'getCellRefValue';
/** @hidden */
export const commputeFormulaValue = 'commputeFormulaValue';
/** @hidden */
export const getChartRowIdxFromClientY = 'getChartRowIdxFromClientY';
/** @hidden */
export const getChartColIdxFromClientX = 'getChartColIdxFromClientX';
/** @hidden */
export const refreshChartCellOnInit = 'refreshChartCellOnInit';
/** @hidden */
export const localizedFormatAction = 'localizedFormatAction';
/** @hidden */
export const moveSheetHandler = 'moveSheetHandler';
/** @hidden */
export const addListValidationDropdown = 'addListValidationDropdown';
/** @hidden */
export const sheetRenameUpdate = 'sheetRenameUpdate';
/** @hidden */
export const updateSortCollection = 'updateSortCollection';
/** @hidden */
export const importModelUpdate = 'importModelUpdate';
